// extracted by mini-css-extract-plugin
export default {"Wrapper":"ItemCategory_Wrapper__fPkco","Title":"ItemCategory_Title__6XPFA"};